import request from './request';

export const setting = {
  phpinfo() {
    return request.get(`setting/phpinfo`, );
  },
}
